import * as React from 'react';
import { SVGProps } from 'react';

const IconFileImageSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 1h14v14H1V1Zm1 1v8.387l1.031-.917a4.5 4.5 0 0 1 5.953-.023l1.002.877a2.892 2.892 0 0 1 3.944.309l.07.077V2H2Zm12 10.194-.81-.887a1.892 1.892 0 0 0-2.465-.287L13.682 14H14v-1.806ZM12.273 14l-2.615-2.635-1.332-1.166a3.5 3.5 0 0 0-4.63.018L2 11.725V14h10.273ZM9.5 4.75a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0ZM11.25 4a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
    />
  </svg>
);
export default IconFileImageSizeS;
